import { apiClient } from '@/lib/api'
import type { BoatWant, BoatMatch, WantCriteria, WantPreview } from '@/types/boat-want'

export interface CreateBoatWantBody {
  customer_id: string
  raw_text: string
  notify_enabled: boolean
  criteria?: WantCriteria
}

export interface UpdateBoatWantBody {
  raw_text: string
  notify_enabled: boolean
  criteria?: WantCriteria
}

export const fetchBoatWants = (customerId: string): Promise<BoatWant[]> =>
  apiClient<BoatWant[]>('/boat-wants', { params: { customer_id: customerId } })

export const createBoatWant = (body: CreateBoatWantBody): Promise<BoatWant> =>
  apiClient<BoatWant>('/boat-wants', { method: 'POST', body })

export const updateBoatWant = (id: string, body: UpdateBoatWantBody): Promise<BoatWant> =>
  apiClient<BoatWant>(`/boat-wants/${id}`, { method: 'PUT', body })

export const deleteBoatWant = (id: string): Promise<void> =>
  apiClient<void>(`/boat-wants/${id}`, { method: 'DELETE' })

export const fetchBoatWantMatches = (wantId: string): Promise<BoatMatch[]> =>
  apiClient<BoatMatch[]>(`/boat-wants/${wantId}/matches`)

// Parse + score without saving: what the dialog shows as the salesperson types.
export const previewBoatWant = (body: {
  raw_text: string
  criteria?: WantCriteria
}): Promise<WantPreview> => apiClient<WantPreview>('/boat-wants/preview', { method: 'POST', body })
